document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.wwh-section').forEach(function (section) {
    var grid = section.querySelectorAll('.wwh-vid');
    var popup = section.querySelector('[data-wwh-popup]');
    if (!popup) return;

    document.body.appendChild(popup);

    var innerVids = popup.querySelectorAll('.wwh-vid-inner');
    var closeBtn = popup.querySelector('.wwh-close-popup');
    var prevBtn = popup.querySelector('.wwh-nav-prev');
    var nextBtn = popup.querySelector('.wwh-nav-next');
    var captionEl = popup.querySelector('.wwh-video-caption');
    var total = innerVids.length;
    var currentIndex = 0;

    function pauseAll(scope) {
      scope.forEach(function (el) {
        var video = el.querySelector('video');
        if (video) video.pause();
      });
    }

    function showIndex(index) {
      currentIndex = index;
      innerVids.forEach(function (el) {
        var isMatch = parseInt(el.dataset.index, 10) === index;
        el.classList.toggle('selected', isMatch);
        var video = el.querySelector('video');
        var poster = el.querySelector('.wwh-video-thumbnail-inner');
        if (isMatch) {
          captionEl.textContent = el.dataset.caption || '';
          if (poster) poster.classList.remove('wwh-hide-poster');
          if (video) {
            video.currentTime = 0;
            video.muted = false;
            var playPromise = video.play();
            if (playPromise && playPromise.catch) {
              playPromise.catch(function () {
                video.muted = true;
                var retry = video.play();
                if (retry && retry.catch) retry.catch(function () {});
              });
            }
          }
        } else if (video) {
          video.pause();
          if (poster) poster.classList.remove('wwh-hide-poster');
        }
      });

      prevBtn.classList.toggle('disabled', currentIndex === 0);
      nextBtn.classList.toggle('disabled', currentIndex === total - 1);
    }

    function openPopup(index) {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      showIndex(index);
    }

    function closePopup() {
      popup.hidden = true;
      document.body.style.overflow = '';
      pauseAll(innerVids);
    }

    grid.forEach(function (card) {
      card.addEventListener('click', function (e) {
        var playBtn = card.querySelector('.wwh-play-btn');
        var muteBtn = card.querySelector('.wwh-mute-btn');
        if (playBtn && (e.target === playBtn || playBtn.contains(e.target))) return;
        if (muteBtn && (e.target === muteBtn || muteBtn.contains(e.target))) return;
        openPopup(parseInt(card.dataset.index, 10));
      });
    });

    grid.forEach(function (card) {
      var wrapper = card.querySelector('.wwh-video-wrapper');
      var playBtn = card.querySelector('.wwh-play-btn');
      var muteBtn = card.querySelector('.wwh-mute-btn');
      var video = card.querySelector('video.wwh-video');
      var poster = card.querySelector('.wwh-video-thumbnail');
      if (!video) return;

      var hideControlsTimer = null;
      function revealControlsBriefly() {
        if (!wrapper) return;
        wrapper.classList.add('show-controls');
        clearTimeout(hideControlsTimer);
        hideControlsTimer = setTimeout(function () {
          wrapper.classList.remove('show-controls');
        }, 2500);
      }

      video.addEventListener('playing', function () {
        if (poster) poster.classList.add('wwh-hide-poster');
        if (wrapper) wrapper.classList.add('is-playing');
        if (playBtn) playBtn.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        if (wrapper) wrapper.classList.remove('is-playing');
        if (playBtn) playBtn.classList.remove('is-playing');
      });

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
          revealControlsBriefly();
        });
      }

      if (muteBtn) {
        function syncMuteIcon() {
          muteBtn.classList.toggle('is-muted', video.muted);
        }
        syncMuteIcon();

        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          syncMuteIcon();
          revealControlsBriefly();
        });

        video.addEventListener('volumechange', syncMuteIcon);
      }

      if (wrapper) {
        wrapper.addEventListener('click', function (e) {
          if (playBtn && (e.target === playBtn || playBtn.contains(e.target))) return;
          if (muteBtn && (e.target === muteBtn || muteBtn.contains(e.target))) return;
          revealControlsBriefly();
        });
      }
    });

    innerVids.forEach(function (el) {
      var wrapper = el.querySelector('.wwh-video-wrapper-inner');
      var playBtn = el.querySelector('.wwh-play-btn-inner');
      var muteBtn = el.querySelector('.wwh-mute-btn');
      var video = el.querySelector('video');
      var poster = el.querySelector('.wwh-video-thumbnail-inner');
      if (!playBtn || !video) return;

      var hideControlsTimer = null;
      function revealControlsBriefly() {
        if (!wrapper) return;
        wrapper.classList.add('show-controls');
        clearTimeout(hideControlsTimer);
        hideControlsTimer = setTimeout(function () {
          wrapper.classList.remove('show-controls');
        }, 2500);
      }

      playBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
        revealControlsBriefly();
      });

      if (wrapper) {
        wrapper.addEventListener('click', function (e) {
          if (e.target === playBtn || playBtn.contains(e.target)) return;
          if (muteBtn && (e.target === muteBtn || muteBtn.contains(e.target))) return;
          revealControlsBriefly();
        });
      }

      video.addEventListener('playing', function () {
        if (poster) poster.classList.add('wwh-hide-poster');
      });

      video.addEventListener('play', function () {
        playBtn.classList.add('is-playing');
        if (wrapper) wrapper.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        playBtn.classList.remove('is-playing');
        if (wrapper) wrapper.classList.remove('is-playing');
      });

      if (muteBtn) {
        video.muted = false;

        function syncMuteIcon() {
          muteBtn.classList.toggle('is-muted', video.muted);
        }
        syncMuteIcon();

        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          syncMuteIcon();
          revealControlsBriefly();
        });

        video.addEventListener('volumechange', syncMuteIcon);
      }
    });

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closePopup();
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (currentIndex > 0) showIndex(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (currentIndex < total - 1) showIndex(currentIndex + 1);
    });

    document.addEventListener('keydown', function (e) {
      if (popup.hidden) return;
      if (e.key === 'Escape') closePopup();
      if (e.key === 'ArrowLeft' && currentIndex > 0) showIndex(currentIndex - 1);
      if (e.key === 'ArrowRight' && currentIndex < total - 1) showIndex(currentIndex + 1);
    });

    var gridTrack = section.querySelector('.wwh-vids--carousel');
    var gridPrev = section.querySelector('.wwh-grid-nav-prev');
    var gridNext = section.querySelector('.wwh-grid-nav-next');

    if (gridTrack && gridPrev && gridNext) {
      function scrollByOneCard(direction) {
        var card = gridTrack.querySelector('.wwh-vid');
        var cardWidth = card ? card.getBoundingClientRect().width + 16 : 200;
        gridTrack.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
      }

      function updateGridNavState() {
        var maxScroll = gridTrack.scrollWidth - gridTrack.clientWidth - 2;
        gridPrev.classList.toggle('disabled', gridTrack.scrollLeft <= 2);
        gridNext.classList.toggle('disabled', gridTrack.scrollLeft >= maxScroll);
      }

      gridPrev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollByOneCard(-1);
      });

      gridNext.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollByOneCard(1);
      });

      gridTrack.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateGridNavState);
      });

      window.addEventListener('resize', updateGridNavState);
      updateGridNavState();
    }
  });
});
